export default __webpack_public_path__ + "static/media/sv5_en_jing_b3.13df1cfa.mp3";